import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

export class ActivityConvertAttachmentCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  data;
  reverseData;

  constructor(data) {
    super(data);
  }

  prepareData() {
    const data = this.object;

    const activity = _.find(
      this.services.jsonHandlerSvc.get().activities,
      act => +act.mxKey === +data.activityMxKey
    );

    const attachment = _.find(
      activity.attachments,
      chr => parseInt(chr.mxKey, 10) === parseInt(data.mxKey, 10)
    );

    this.reverseData = {
      title: attachment.title,
      value: attachment.value,
      type: attachment.type,
      groups: attachment.groups || [],
      activityMxKey: +data.activityMxKey,
      mxKey: data.mxKey
    };

    return this;
  }

  public execute() {
    super.execute();
    const data = this.object;

    const param = {
      itemMxKey: data.activityMxKey,
      mxKey: data.mxKey,
      title: data.title,
      value: data.value,
      type: data.type,
      groups: data.groups,
      description: data.description,
      tags: data.tags,
      urlEntry: data.urlEntry
    };

    const action = {convertTolUrlEntryAttachment: param};

    return this.services.diagramUpdateSvc.update(action).then(() => param);
  }

  public reverse() {
    super.execute();
    const data = this.reverseData;
    const param = {
      itemMxKey: data.activityMxKey,
      mxKey: data.mxKey,
      title: data.title,
      type: data.type,
      value: data.value,
      groups: data.groups
    };

    const action = {convertTolUrlEntryAttachment: param};

    return this.services.diagramUpdateSvc.update(action);
  }
}
